export const messages = {
  en: {
    shopCommunityManage: {
      queryCondition: 'Query Conditions',
      selectStatus: 'Select Status',
      inputCommunityCode: 'Input Community Code',
      inputCommunityName: 'Input Community Name',
      settledCommunity: 'Settled Community',
      settle: 'Settle',
      communityCode: 'Community Code',
      communityName: 'Community Name',
      communityAddress: 'Community Address',
      cityCode: 'City Code',
      settleTime: 'Settle Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      communityArea: 'Community Area',
      selectProvince: 'Select Province',
      selectCity: 'Select City',
      selectDistrict: 'Select District',
      community: 'Community',
      selectCommunityRequired: 'Required, please select community',
      confirmDeleteShopCommunity: 'Confirm to delete shop community?',
      editShopCommunity: 'Edit Shop Community',
      getAreaFailed: 'Failed to get area data',
      queryCommunityFailed: 'Failed to query community'
    }
  },
  zh: {
    shopCommunityManage: {
      queryCondition: '查询条件',
      selectStatus: '请选择状态',
      inputCommunityCode: '请输入小区编码',
      inputCommunityName: '请输入小区名称',
      settledCommunity: '入驻小区',
      settle: '入驻',
      communityCode: '小区编码',
      communityName: '小区名称',
      communityAddress: '小区地址',
      cityCode: '城市编码',
      settleTime: '入驻时间',
      startTime: '开始时间',
      endTime: '结束时间',
      status: '状态',
      communityArea: '小区地区',
      selectProvince: '请选择省',
      selectCity: '请选择城市',
      selectDistrict: '请选择区县',
      community: '小区',
      selectCommunityRequired: '必填，请选择小区',
      confirmDeleteShopCommunity: '确定删除店铺小区？',
      editShopCommunity: '修改店铺小区',
      getAreaFailed: '获取地区数据失败',
      queryCommunityFailed: '查询小区失败'
    }
  }
}